import React, { useEffect } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { useOpened, useSelected } from './module/home/hook'
import { useDomainList, useDomainValidEmailList } from './module/domain/hook'
import SideMenu from './components/common/SideMenu'
import { ProductType } from './types'
import { initialDomain, initialUser } from './module/home/context'

function App() {
  const { openSidemenu, setOpenSidemenu, setOpenDomainAddModal, setOpenEmailAddModal } = useOpened()
  const { setSelectedProductType, setSelectedDomain, setIsValidEmailType } = useSelected()
  const { setFilterText: setDomainFilter, setSelectedDomain: setDomainListSelected } =
    useDomainList()
  const { setFilterText: setEmailFilter } = useDomainValidEmailList()
  const { pathname } = useLocation()
  const { productId, domain } = useParams()

  useEffect(() => {
    const homepath = '/'

    setDomainFilter('')
    setEmailFilter('')
    setOpenDomainAddModal(false)
    setOpenEmailAddModal(false)
    setOpenSidemenu(pathname !== homepath)
    setIsValidEmailType(pathname.endsWith('/list'))
    setDomainListSelected(null)

    if (productId) {
      setSelectedProductType(productId as ProductType)
      if (!domain) {
        setSelectedDomain(initialUser)
      }
    }
  }, [pathname])

  return (
    <div className='flex w-screen h-screen bg-slate-200'>
      {openSidemenu && <SideMenu />}
      <Outlet />
    </div>
  )
}

export default App
